import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import numeral from 'numeral';
import { Button, Input, Icon, Table, Image, Divider } from 'semantic-ui-react';
import DyzioModal from 'dyzio-shared-components/lib/components/dyzio-modal';

const cf = num => numeral(num).format('0a');

const modalTableStyle = {
  height: 430,
  display: 'block',
  overflowY: 'scroll',
};

const noResultsDivStyle = {
  width: '100%',
  height: 430,
  textAlign: 'center',
  paddingTop: 120,
  color: 'gray',
};

// TODO: MOVE THIS TO A COMPONENT
const InfluencerSearchTableRow = props => {
  const { lookupInfluencer: influencer, influencers, onInviteInfluencer } = props;
  const isAlreadyAMember = _.find(influencers, ['id', influencer.id]);
  return (
    <Table.Row>
      <Table.Cell collapsing>
        <Image src={influencer.thumbnail} avatar size="mini" />
      </Table.Cell>
      <Table.Cell>
        {influencer.name}
      </Table.Cell>
      <Table.Cell>
        { cf(influencer.facebookCount) }
      </Table.Cell>
      <Table.Cell>
        { cf(influencer.instagramCount) }
      </Table.Cell>
      <Table.Cell>
        { cf(influencer.twitterCount) }
      </Table.Cell>
      <Table.Cell>
        { cf(influencer.youtubeCount) }
      </Table.Cell>
      <Table.Cell>
        {influencer.email || 'No email'}
      </Table.Cell>
      <Table.Cell>
        <Button
          fluid
          disabled={isAlreadyAMember}
          color="pink"
          content={isAlreadyAMember ? 'Added' : 'Add'}
          onClick={() => onInviteInfluencer(influencer)}
        />
      </Table.Cell>
    </Table.Row>
  );
};

// TODO: MOVE THIS TO A COMPONENT
const InfluencerSearchResultsTable = props => {
  const { results, influencers, onInviteInfluencer } = props;
  return (
    <Table unstackable fluid>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan={2}>Influencer</Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            <img src="/icons/facebook.svg" alt="Facebook" />
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            <img src="/icons/instagram.svg" alt="Instagram" />
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            <img src="/icons/twitter.svg" alt="Twitter" />
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
            <img src="/icons/youtube.svg" alt="YouTube" />
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center">
              Email
          </Table.HeaderCell>
          <Table.HeaderCell textAlign="center" collapsing>Action</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        { _.map(results, result => <InfluencerSearchTableRow
          {...result}
          influencers={influencers}
          onInviteInfluencer={onInviteInfluencer}
        />)
        }
      </Table.Body>
    </Table>
  );
};

const AddInfluencerModal = props => {
  const {
    toggleHandler,
    isSearching,
    onInfluencerQueryChanged,
    results,
    influencers,
    onInviteInfluencer,
  } = props;

  return (
    <DyzioModal
      open
      headerText="Add an influencer"
      onClose={toggleHandler}
    >
      <Input loading={isSearching} onChange={onInfluencerQueryChanged} fluid placeholder="Search my influencers..." />
      <Divider />
      {
        (!results || _.isEmpty(results)) &&
          <div style={noResultsDivStyle}>
            <Icon name="search" size="massive" />
            <br />
            <h4>Search influencers</h4>
          </div>
      }
      {
        results && !_.isEmpty(results) &&
          <div style={modalTableStyle}>
            <InfluencerSearchResultsTable
              results={results}
              influencers={influencers}
              onInviteInfluencer={onInviteInfluencer}
            />
          </div>
      }
    </DyzioModal>
  );
};

AddInfluencerModal.propTypes = {
  toggleHandler: PropTypes.func.isRequired,
  onInfluencerQueryChanged: PropTypes.func.isRequired,
  onInviteInfluencer: PropTypes.func.isRequired,
  isSearching: PropTypes.bool.isRequired,
  results: PropTypes.array.isRequired,
  influencers: PropTypes.array.isRequired,
};

export default AddInfluencerModal;



/** WEBPACK FOOTER **
 ** ./src/components/add-influencer-modal/index.js
 **/